import { createFileRoute } from '@tanstack/react-router';

import { MenuEditorPage, menuQueryOptions } from '@/features/menus';

export const Route = createFileRoute('/_authed/_active/s/$storeId/content/menus/$menuId')({
  staticData: { tours: ['content.menu-editor'] },
  loader: async ({ context, params }) => {
    const menu = await context.queryClient.query({
      ...menuQueryOptions(params.storeId, params.menuId),
      staleTime: 'static',
    });
    return { crumb: menu.title };
  },
  component: MenuEditorPage,
});
